/* eslint-disable react/prop-types */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import OfflineCheck from '../OfflineCheck';
import styles from './NoBound.less';

export class NoBound extends Component {
  render() {
    const bodyClassName = classNames(styles.layoutBase, this.props.bodyClass);

    return (
      <Fragment>
        <Helmet>
          <body className={bodyClassName} />
        </Helmet>
        {this.props.children}
        <OfflineCheck />
        
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...state,
  test: ownProps.location,
});

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NoBound);
